/**
 * Отключает прокрутку страницы, обычно используется при открытии модальных окон.
 * - Сохраняет ширину полосы прокрутки в пользовательском свойстве `--scrollbar-width` для предотвращения смещения контента.
 * - Устанавливает стиль `overflow: hidden` на body для блокировки прокрутки.
 * - Добавляет класс `modal-open` для применения соответствующих стилей.
 */
export function disableScroll() {
  const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
  document.body.style.setProperty('--scrollbar-width', `${scrollBarWidth}px`);        
  document.body.style.overflow = "hidden";
  document.body.classList.add('modal-open');
}

/**
* Включает прокрутку страницы, обычно используется при закрытии модальных окон.
* - Убирает класс `modal-open` с body, восстанавливает стандартное поведение прокрутки.
* - Удаляет пользовательское свойство `--scrollbar-width`, которое было установлено при отключении прокрутки.
* - Восстанавливает стиль `overflow: auto`, разрешая прокрутку страницы.
*/
export function enableScroll() {
  document.body.classList.remove('modal-open');
  document.body.style.removeProperty('--scrollbar-width');
  document.body.style.overflow = 'auto'; 
}

/**
* Переключает состояние прокрутки в зависимости от того, открыто ли модальное окно.
* @param {boolean} isModalOpen - Флаг, указывающий, открыто ли модальное окно.
* Если `isModalOpen` истинно, прокрутка отключается, если ложно — прокрутка включается.
*/
export const toggleScroll = (isModalOpen) => isModalOpen
? disableScroll()
: enableScroll();

/**
* Прокручивает страницу в верхнюю часть.
* Это может быть полезно, например, при переходе на другую страницу или при открытии модального окна.
*/
export const scrollToTop = () => {
  window.scrollTo(0, 0);
}

  /**
 * Прокручивает страницу до элемента с указанным id.
 * @param {string} elementId - ID элемента для прокрутки.
 * @param {number} delay - Задержка перед прокруткой в миллисекундах.
 */
export const scrollToElement = (elementId, delay = 300) => {
  const savedPosition = localStorage.getItem('scrollTo');
  if (savedPosition === elementId) {
    setTimeout(() => {
      window.scrollTo({
        top: Number(document.getElementById(elementId)?.offsetTop ?? 0),
        behavior: "smooth"
      });
    }, delay);
    localStorage.removeItem('scrollTo');
  }
};

/**
 * Добавляет обработчик события прокрутки.
 * @param {Function} onScrollCallback - Функция обратного вызова для обработки события прокрутки.
 */
export const addScrollListener = (onScrollCallback) => {
  window.addEventListener('scroll', onScrollCallback);
};

/**
 * Убирает обработчик события прокрутки.
 * @param {Function} onScrollCallback - Функция обратного вызова для удаления обработчика.
 */
export const removeScrollListener = (onScrollCallback) => {
  window.removeEventListener('scroll', onScrollCallback);
};
